<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.58 8.46c.58.6.56 1.55-.04 2.12l-4.6 4.43a3.5 3.5 0 0 1-4.89 0L6.5 13.6a1.5 1.5 0 1 1 2-2.22l1.6 1.43c.23.23.55.23.74.04l4.62-4.44a1.5 1.5 0 0 1 2.12.04M24 12A12.01 12.01 0 1 1 12 0c6.62 0 12 5.38 12 12m-3 0a9.01 9.01 0 0 0-18 0 9.01 9.01 0 0 0 18 0"/></svg>
</template>
